import { toast as sonnerToast, type ExternalToast } from "sonner";

/** The app's toast surface — extend with more sonner methods as needed. */
export const toast = {
  success: (message: string, options?: ExternalToast) =>
    sonnerToast.success(message, options),

  error: (message: string, options?: ExternalToast) =>
    sonnerToast.error(message, options),
};
